import { Component, ElementRef, OnDestroy, OnInit } from "@angular/core";
import { ResponsiveService } from "@app/services/responsive.service";
import { CanvasService } from "@services/canvas.service";
import * as angular from "angular";
import { Subscription } from "rxjs";
import "./vector-dots.component.scss";

interface IStar {
    x: number;
    y: number;
    radius: number;
    vx: number;
    vy: number;
}
@Component({
    selector: 'vector-dots',
    template: "<canvas></canvas>"
})
export class VectorDotsComponent implements OnInit, OnDestroy {
    canvas: HTMLCanvasElement;
    ctx: CanvasRenderingContext2D;
    stop: boolean;

    stars: IStar[];
    FPS = 60;
    numStars = navigator.hardwareConcurrency * 2;
    mouse = { x: 0, y: 0 }

    width: number;
    height: number;

    private subscriptons = new Subscription();
    
    constructor(
        private readonly el: ElementRef,
        private readonly canvasService: CanvasService,
        private readonly responsiveService: ResponsiveService) {
    }

    ngOnInit() {
        this.createCanvas();
        this.createStars();
        this.animateFrame();

        this.subscriptons.add(this.responsiveService.currentWindowWidth$.subscribe(() => { this.createCanvas(); }));
    }

    ngOnDestroy() {
        this.stop = true;
        this.subscriptons.unsubscribe();

        this.canvasService.destroyCachedImageCanvases();
    }

    // ---

    private createCanvas() {

        this.canvas = this.el.nativeElement.querySelector('canvas') as HTMLCanvasElement;
        this.ctx = this.canvas.getContext("2d");

        const rect = this.el.nativeElement.getBoundingClientRect();
        this.width = rect.width || this.canvas.width;
        this.height = rect.height || this.canvas.height;

        this.canvas.width = this.width;
        this.canvas.height = this.height;
    }

    private animateFrame() {
        if (this.stop) {
            return;
        }

        window.requestAnimationFrame(() => {
            performance.mark("vectorDotsAnimateFrame");

            this.draw();
            this.update()

            performance.measure("vectorDotsAnimateFrame");

            this.animateFrame();
        });
    }

    private draw(draw = true) {

        this.ctx.clearRect(0, 0, this.width, this.height);

        this.ctx.globalCompositeOperation = "lighter";

        for (var i = 0, x = this.stars.length; i < x; i++) {
            var s = this.stars[i];

            this.ctx.fillStyle = "#fff";
            this.ctx.beginPath();
            this.ctx.arc(s.x, s.y, s.radius, 0, 2 * Math.PI);
            this.ctx.fill();
            this.ctx.fillStyle = 'black';
            this.ctx.stroke();
        }

        this.ctx.beginPath();
        for (var i = 0, x = this.stars.length; i < x; i++) {
            var starI = this.stars[i];
            this.ctx.moveTo(starI.x, starI.y);

            if (this.distance(this.mouse, starI) < 150) {
                this.ctx.lineTo(this.mouse.x, this.mouse.y);
            }

            for (var j = 0, x = this.stars.length; j < x; j++) {
                var starII = this.stars[j];

                if (this.distance(starI, starII) < 150) {
                    //ctx.globalAlpha = (1 / 150 * distance(starI, starII).toFixed(1));
                    this.ctx.lineTo(starII.x, starII.y);
                }
            }
        }

        this.ctx.lineWidth = 0.05;
        this.ctx.strokeStyle = 'white';
        this.ctx.stroke();
    }

    private createStars(): IStar[] {
        this.stars = [];

        for (var i = 0; i < this.numStars; i++) {
            var velocity = 50;
            velocity = 25;

            this.stars.push({
                x: Math.random() * this.width,
                y: Math.random() * this.height,
                radius: Math.random() * 1 + 1,
                vx: Math.floor(Math.random() * velocity) - (velocity / 2),
                vy: Math.floor(Math.random() * velocity) - (velocity / 2)
            });
        }

        return this.stars;
    }

    private distance(point1, point2) {
        var xs = 0;
        var ys = 0;

        xs = point2.x - point1.x;
        xs = xs * xs;

        ys = point2.y - point1.y;
        ys = ys * ys;

        return Math.sqrt(xs + ys);
    }

    private update() {

        for (var i = 0, x = this.stars.length; i < x; i++) {
            var s = this.stars[i];

            s.x += s.vx / this.FPS;
            s.y += s.vy / this.FPS;

            if (s.x < 0 || s.x > this.width) s.vx = -s.vx;
            if (s.y < 0 || s.y > this.height) s.vy = -s.vy;
        }
    }
}

//export class VectorDotsComponent implements angular.IComponentOptions {
//    bindings: any;
//    controller: any;
//    template: string;

//    constructor() {
//        this.bindings = {
//        };

//        this.controller = Controller;
//        this.template = "<canvas></canvas>";
//    }
//}
